
import {Box, Paper, Stack, Button, IconButton, Typography} from "@mui/material";
import { useCommonStyles } from '../../styles/GenericStyle';
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import type { FloatingBarProps } from '../../model/commonType';


export function FloatingActionBar({
    open,
    selectedCount = 0,
    onExport,
    onPrint,
    onClose,
    onAction,
    type,
    hideActions = false,
    onMoveMaterials,
    customActions = []
}: FloatingBarProps) {

    const classes = useCommonStyles();
    if (!open) return null;


const invokeAction = () => {
onAction && onAction([], "floater");
}
    return (
        <Box
            sx={{
                position: "fixed",
                left: "55%",
                bottom: 5,
                transform: "translateX(-50%)",                
                height: 50,
                width: 600,                
            }}>
            <Paper
                elevation={8}
                sx={{
                    py: 1,
                     borderRadius: 999,
                    bgcolor: "#0A0A0A",
                    color: "common.white",
                    display: "inline-flex",
                    alignItems: "center",
                    minHeight: 50,
                    maxWidth: "calc(100vw - 32px)",
                }}>
                <Stack
                    direction="row"
                    alignItems="center">
                    <Typography
                        variant="body2"
                        className={classes.gridRowText}
                        sx={{
                            px: 3,
                            whiteSpace: "nowrap",
                            color: "#FFFFFF"
                        }}>
                        {selectedCount} {type=="splot" ? "SPLots" : type=="material" || type==="trial-material" ? "Materials" : "Items"} selected
                    </Typography>
                    {type === "material" && <><Box sx={{ borderRight: 1, borderColor: "#4A5565", height: 27 }}></Box>
                    <Stack direction="row" alignItems="center">
                        <Box sx={{ ml: 2 }}>
                            <Button
                                onClick={onMoveMaterials}
                                startIcon={<ExitToAppIcon sx={{ fontSize: 14 }} />}
                                disableRipple
                                className={classes.gridRowText}
                                sx={{
                                    color: "#FFFFFF",
                                    textTransform: "none",
                                    whiteSpace: "nowrap",
                                    "&:focus": {
                                        boxShadow: "none",
                                        outline: "none"
                                    }
                                }}
                            >
                                Move to SP Lot
                            </Button>
                        </Box>
                        <Box sx={{ borderRight: 1, borderColor: "#4A5565", height: 27, ml: 3 }}></Box>
                    </Stack></>}
                    {type === "trial" && <><Box sx={{ borderRight: 1, borderColor: "#4A5565", height: 27 }}></Box>
                    <Stack direction="row" alignItems="center">
                        <Box sx={{ ml: 2 }}>
                            <Button
                                onClick={onExport}
                                startIcon={<FileDownloadOutlinedIcon sx={{ fontSize: 14 }} />}
                                disableRipple
                                className={classes.gridRowText}
                                sx={{
                                    color: "#FFFFFF",
                                    textTransform: "none",
                                    whiteSpace: "nowrap",
                                    "&:focus": {
                                        boxShadow: "none",
                                        outline: "none"
                                    }
                                }}
                            >
                                Download
                            </Button>
                        </Box>
                        <Box sx={{ borderRight: 1, borderColor: "#4A5565", height: 27, ml: 3 }}></Box>
                    </Stack></>}
                    {customActions.length > 0 && <>
                        <Box sx={{ borderRight: 1, borderColor: "#4A5565", height: 27 }}></Box>
                        <Stack direction="row" alignItems="center">
                            {customActions.map((action, index) => (
                                <Stack key={`${action.label}-${index}`} direction="row" alignItems="center">
                                    <Box sx={{ ml: index === 0 ? 2 : 3 }}>
                                        <Button
                                            onClick={action.disabled ? undefined : action.onClick}
                                            disabled={!!action.disabled}
                                            disableRipple
                                            className={classes.gridRowText}
                                            sx={{
                                                color: "#FFFFFF",
                                                textTransform: "none",
                                                whiteSpace: "nowrap",
                                                opacity: action.disabled ? 0.45 : 1,
                                                cursor: action.disabled ? 'not-allowed' : 'pointer',
                                                '&.Mui-disabled': {
                                                    color: '#FFFFFF',
                                                    cursor: 'not-allowed',
                                                    pointerEvents: 'auto',
                                                },
                                                "&:focus": {
                                                    boxShadow: "none",
                                                    outline: "none"
                                                }
                                            }}
                                        >
                                            {action.label}
                                        </Button>
                                    </Box>
                                    {index < customActions.length - 1 && (
                                        <Box sx={{ borderRight: 1, borderColor: "#4A5565", height: 27, ml: 3 }}></Box>
                                    )}
                                </Stack>
                            ))}
                            <Box sx={{ borderRight: 1, borderColor: "#4A5565", height: 27, ml: 3 }}></Box>
                        </Stack>
                    </>}
                    {!hideActions && <><Box sx={{ borderRight: 1, borderColor: "#4A5565", height: 27 }}></Box>
                    <Stack direction="row" alignItems="center" >

                        <Box sx={{ ml: 2 }}>
                           {type=="splot" ?  <Button

                                onClick={onPrint}
                                startIcon={<img
                                    src={"icons/white_print.svg"}
                                    alt="Save"
                                    width={14}
                                    height={14}
                                    style={{ display: "block" }}

                                />}
                                disableRipple
                                className={classes.gridRowText}
                                sx={{
                                    color: "#FFFFFF",
                                    textTransform: "none",
                                    "&:focus": {
                                        boxShadow: "none",
                                        outline: "none"
                                    }
                                }}
                            >
                                   Print Label
                            </Button> : 
                            <Button

                                //onClick={() =>{() => onAction && onAction([], "floater")}}
                                onClick={invokeAction}
                                startIcon={<img
                                    src={"icons/multipleHarvest.svg"}
                                    alt="Save"
                                    width={14}
                                    height={14}
                                    style={{ display: "block" }}

                                />}
                                disableRipple
                                className={classes.gridRowText}
                                sx={{
                                    color: "#FFFFFF",
                                    textTransform: "none",
                                    "&:focus": {
                                        boxShadow: "none",
                                        outline: "none"
                                    }
                                }}>
                                Create another harvest
                            </Button>
                        
                        
                        }
                            {/* <Button
                                className={classes.gridRowText}
                                variant="contained"
                                disableRipple
                                disableFocusRipple
                                onClick={onDelete}
                                startIcon={<img
                                    src={"icons/white_delete.svg"}
                                    alt="Save"
                                    width={14}
                                    height={14}
                                    style={{ display: "block" }}

                                />}
                                sx={{
                                    textTransform: "none",
                                    ml: 3,
                                    bgcolor: "#E7000B",
                                    borderRadius: 8,
                                    height: 31,
                                    px: 2.5,
                                    color: "#FFFFFF",
                                    "&:focus": {
                                        boxShadow: "none", borderColor: "#000000",
                                        outline: "none", 
                                    }

                                }}>
                                Delete
                            </Button> */}

                        </Box>
                        <Box sx={{
                            borderRight: 1,
                            borderColor: "#4A5565",
                            height: 27,
                            ml: 3
                        }}></Box>
                    </Stack></>}
                    <Box sx={{ px: 2 }}>
                        <IconButton
                            size="small"
                            onClick={onClose}
                            disableRipple
                            disableFocusRipple
                            sx={{
                                fontSize: 16,
                                color: "#FFFFFF",
                                "&:focus": {
                                    boxShadow: "none",
                                    outline: "none"
                                }
                            }}
                        >
                            <CloseRoundedIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Stack>
            </Paper>
        </Box>
    );
}